const dev = {
   APIURL: "https://stagingapi.kid-ex.com",
   // APIURL: "https://devapi.kid-ex.com",
   TENANT_KEY: "044a030b-a0cd-412b-8539-aa3a80a8ecd1",
   // TENANT_KEY: "c0a2521b-dd47-44d7-a367-d57243b89de4",
   WEB_URL: "http://kid-ex.com",
   AWES_LOGO: "https://cdn.kid-ex.com/SchoolImages/APS_Schools.jpg",
   AWES_TAG_LINE: "School Login Portal",
   SCHOOL_DASHBOARD_URL: "https://staging.kid-ex.com/school-dashboard",
   AWES_SCHOOL_DASHBOARD_URL: "https://sanfortstaging.kid-ex.com/school-dashboard",
}
const prod = {
   APIURL: window?._env_?.API_URL,
   TENANT_KEY: window?._env_?.TENANT_KEY,
   WEB_URL: window?._env_?.WEB_URL,
   AWES_LOGO: window?._env_?.AWES_LOGO,
   AWES_TAG_LINE: window?._env_?.AWES_TAG_LINE,
   SCHOOL_DASHBOARD_URL: window?._env_?.SCHOOL_DASHBOARD_URL,
   AWES_SCHOOL_DASHBOARD_URL: window?._env_?.AWES_SCHOOL_DASHBOARD_URL,
}
export const config = process.env.NODE_ENV === "development" ? dev : prod
export default { config };